/**
 * adapted from https://codepen.io/tigt/post/optimizing-svgs-in-data-uris
 */
export function prepareSVGAsDataURI(rawSVG) {
    const prefix = 'data:image/svg+xml,';
    let svg = encodeURIComponent(rawSVG.replace(/\n+/g, ''));

    // restore ASCII-safe characters
    svg = svg.replace(/%20/g, ' '); // spaces
    svg = svg.replace(/%3D/g, '='); // equal signs
    svg = svg.replace(/%3A/g, ':'); // colons
    svg = svg.replace(/%2F/g, '/'); // slashes

    // replace quotes with apostrophes (may break certain SVGs)
    // this allows the consumer to safely encase the data URI string in double quotes as we do in JSX templates, etc.
    svg = svg.replace(/%22/g, "'");

    return `${prefix}${svg}`;
}

export const getLogo = theme => theme.header.logo;
